import { PageLayout } from '../../PageLayout';

export const Processing = () => {
  return (
    <PageLayout
      dataTestId="processing-page"
      pageTitle="Processing">
      <div>page contents</div>
    </PageLayout>
  );
};
